// extracted by mini-css-extract-plugin
module.exports = {"pane":"h_x","paneflex":"h_y h_x"};